import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import {
  desktopBreakpoint,
  mobileBreakpoint,
  tabletBreakpoint,
} from '@/src/domains/shared/breakpoints';

export { default as RemoteLogo } from './RemoteLogo';
export { default as InstagramLogo } from './InstagramLogo';
export { default as LinkedinLogo } from './LinkedinLogo';
export { default as YoutubeLogo } from './YoutubeLogo';
export { default as TwitterLogo } from './TwitterLogo';
export { default as RemoteBrandLogo } from './RemoteBrandLogo';

export const FooterContainer = styled.footer`
  ${fluidProp('padding-top', '60px', '90px')}
  ${fluidProp('padding-bottom', '40px', '60px')}
  ${fluidProp('font-size', '12px', '14px')}
  color: var(--colors-blank);
  background-color: var(--colors-darkBlue);
`;

export const Container = styled(ContentContainer)`
  display: flex;
  justify-content: space-between;
  padding-bottom: 60px;

  ${tabletBreakpoint(css`
    flex-direction: column;
    padding-bottom: 20px;
  `)}
`;

export const Title = styled.h2`
  ${fluidProp('font-size', '14px', '17px')}
  line-height: 1.4em;
  font-weight: 500;
  color: var(--colors-mischka);
  margin-bottom: 15px;
  margin-top: 0;
  text-transform: uppercase;
`;

export const Link = styled.a`
  color: var(--colors-mischka);
  opacity: 0.6;
  transition: opacity 0.2s;
  margin-top: 10px;

  &:hover {
    opacity: 1;
  }

  & + & {
    margin-top: 15px;
  }
`;

export const FooterWrapper = styled.div`
  width: 70%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;

  ${tabletBreakpoint(css`
    width: 100%;
    grid-template-columns: repeat(2, 1fr);
  `)}

  ${mobileBreakpoint(css`
    grid-template-columns: 1fr;
  `)}
`;

export const FooterInner = styled.nav`
  width: 100%;
  display: flex;

  ${tabletBreakpoint(css`
    margin-bottom: 50px;
  `)}
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ColumnBody = styled(Column)``;

export const FooterBottom = styled(ContentContainer)`
  display: flex;
  justify-content: space-between;
  padding: 40px 0 0 0;
  border-top: 1px solid ${({ theme }) => theme.colors.selago_15};

  ${desktopBreakpoint(css`
    margin: 0 40px;
  `)}

  ${tabletBreakpoint(css`
    flex-direction: column;
    text-align: center;
    margin: 0 20px;
  `)}
`;

export const Copyright = styled.div`
  margin-top: 10px;
  color: var(--colors-mischka);
  opacity: 0.8;

  ${tabletBreakpoint(css`
    order: 1;
  `)}
`;

export const FooterIcons = styled.div`
  width: 133px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;

  ${tabletBreakpoint(css`
    order: 0;
    margin: auto;
    padding-bottom: 10px;
  `)}
`;

export const SocialLink = styled.a`
  color: var(--colors-mischka);
  opacity: 1;
`;
